import React from "react";
import { alpha, Box, Paper, Typography, useTheme } from "@mui/material";

export const NarrativeExample: React.FC<{ example?: string }> = ({ example }) => {
  const theme = useTheme();
  if (!example) return null;

  return (
    <Box>
      <Typography
        variant="subtitle2"
        sx={{
          mb: 1.5,
          fontWeight: 600,
          color: theme.palette.text.primary,
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        Example Narrative
      </Typography>
      <Paper
        elevation={0}
        sx={{
          p: 2,
          backgroundColor: alpha(theme.palette.primary.main, 0.03),
          borderRadius: 2,
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
          maxHeight: 650,
          flex: 1,
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            whiteSpace: "pre-wrap",
            fontSize: "0.75rem",
            fontFamily: "monospace",
            textAlign: "left",
            lineHeight: 1.6,
          }}
        >
          {example}
        </Typography>
      </Paper>
    </Box>
  );
};
